// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"b9b70081","315":"01925ef5","409":"d99ee919","463":"5db5f341","473":"4260a0ab","611":"c5afe7e1","741":"468692c2","774":"b8cf00d1","787":"2616d46f","883":"466d406e"}[chunkId] + ".chunk.js";
};